module.exports = __webpack_public_path__ + "static/media/Gotham-Light.c612f97c.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./src/fonts/Gotham-Light.eot
 ** module id = 1338
 ** module chunks = 0
 **/